export default "__VITE_ASSET__JQW3hM1q__"